var jQuery = require('jquery');
var notify = require('notifyjs-browser');

var styleDefinition = {
    html: "<div><span data-notify-text/></div>",
    classes: {
        base: {
            "white-space": "nowrap",
            "background-color": "#FFFFFF",
            "color": "#FFFFFF",
            "padding": "8px 16px 8px 50px",
            "border-radius": "6px",
            "margin-bottom": "12px",
            "box-shadow": "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
            "font-family": "AvertaStd-Bold",
            "font-weight": "normal",
            "border": "1px solid",
        },
        error: {
            "color": "#e54545",
        },
        success: {
            "color": "#2caa03",
        },
        info: {
            "color": "#00b9d2",
        },
        warning: {
            "color": "#f7bd00",
        }
    }
};

jQuery.notify.addStyle( 'streampush', styleDefinition );

if( sp_notifications )
{
    JSON.parse( sp_notifications ).forEach( function ( notification ) 
    {
        jQuery.notify(notification.message, {
            style: 'streampush', 
            className: notification.type,
            autoHide: notification.autoHide,
            gap: 8,
            autoHideDelay: 15000,
        });
    });
}

export function addNotification(message, type) 
{
    jQuery.notify(message, {
        style: 'streampush', 
        className: type,
        gap: 8,
        autoHideDelay: 15000,
    });
};